import { Autocomplete, LinearProgress, TextField } from "@mui/material";
import type { FC } from "react";
import { useProducts } from "../admin/products/useProducts";

interface Props {
  readonly imageProducts: string[];
  readonly setImageProducts: (imageProducts: string[]) => void;
}

const SelectImageProducts: FC<Props> = ({ imageProducts, setImageProducts }) => {
  const { products, isLoading } = useProducts();
  const options = products.map((p) => ({ id: p.id, label: p.name }));
  const selectedOptions = options.filter((p) => imageProducts.includes(p.id));

  if (isLoading) {
    return <LinearProgress />;
  }
  return (
    <Autocomplete
      loading={isLoading}
      disableClearable={false}
      fullWidth={true}
      multiple={true}
      size={"medium"}
      disabled={false}
      value={selectedOptions}
      options={options}
      sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
      onChange={(e, selected) => {
        setImageProducts(selected.map((p) => p.id));
      }}
      renderInput={(params) => <TextField {...params} label={"Przypisane produkty"} />}
    />
  );
};

export default SelectImageProducts;
